module.exports = __webpack_public_path__ + "img/icon-sand-clock.15a4d1cf.svg";